import React from 'react';
import { Row, Col, Card, Typography, Space } from 'antd';
import ResumeBarChart from '../../graphics/resumeBarChart';
import ScoreTierLegend from '../scoreTierLegend/scoreTierLegend';

const { Title, Text } = Typography;

const CultureSummary = ({ data, globalAverage, title, redLight, yellowLight, isMain }) => {
    // Para cultura, construimos la data del gráfico desde average_by_categories
    const categories = Array.isArray(data?.average_by_categories) ? data.average_by_categories : [];
    const dimensions = categories.map(cat => ({ title: cat.name, average: cat.average }));

    // Cobertura y encuestas realizadas
    const relationshipsTotal = Number(data?.relationships_total || 0);
    const relationshipsFinished = Number(data?.relationships_finished || 0);
    const coverage = relationshipsTotal > 0
        ? Math.round((relationshipsFinished / relationshipsTotal) * 1000) / 10
        : 0;

    if (!dimensions || dimensions.length === 0) return null;
    const best = dimensions.reduce((max, d) => (d.average > max.average ? d : max), dimensions[0]);
    const worst = dimensions.reduce((min, d) => (d.average < min.average ? d : min), dimensions[0]);

    const getColor = (value) => {
        if (value <= redLight) return "#e53935"; // rojo
        if (value <= yellowLight) return "#fbc02d"; // amarillo
        return "#43a047"; // verde
    };

    const getContrastTextColor = (bgColor) =>
        String(bgColor).toLowerCase() === '#fbc02d' ? '#000' : '#fff';

    const globalBgColor = getColor(globalAverage);
    const globalTextColor = getContrastTextColor(globalBgColor);

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Row gutter={[16, 16]} align="stretch">
                <Col xs={24} md={16}>
                    <ScoreTierLegend redLight={redLight} yellowLight={yellowLight} />
                </Col>
                <Col xs={24} md={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Card
                        style={{
                            backgroundColor: globalBgColor,
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: "100%",
                            width: "100%"
                        }}
                    >
                        <Text style={{ fontSize: 16, marginBottom: 10, color: globalTextColor }}>Global Compañía</Text>
                        <br />
                        <Text style={{ fontSize: 32, fontWeight: "bold", color: globalTextColor }}>{globalAverage}%</Text>
                    </Card>
                </Col>
            </Row>
            {/* Gráfico y promedio global */}
            <Row gutter={[16, 16]}>
                <Col xs={24} md={24}>
                    <ResumeBarChart data={dimensions} redLight={redLight} yellowLight={yellowLight} />
                </Col>
            </Row>

            {
                !isMain && <>
                    {/* Card de cobertura y encuestas realizadas */}
                    <Row gutter={[16, 16]} align="stretch">
                        <Col xs={24} md={24}>
                            <Card bordered style={{ 
                                display: 'flex', 
                                textAlign: 'center',
                                flexDirection: 'column',
                                justifyContent: 'space-around',
                                alignItems: 'space-around',
                                width: "100%"
                            }}>
                                <Row style={{ width: '100%' }} align="middle" gutter={[0, 0]} justify="space-between" wrap={false}>
                                    <Col xs={24} md={8} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <img src="/informs/persons.png" alt="Persons" style={{ width: '100%', maxWidth: 220, height: 120, objectFit: 'contain' }} />
                                    </Col>
                                    <Col xs={24} md={8} style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        <Text style={{ fontSize: 14, color: '#339C98' }}>Cobertura total</Text>
                                        <div style={{ fontSize: 32, fontWeight: 600, color: '#3E246B' }}>{coverage}%</div>
                                    </Col>
                                    <Col xs={24} md={8} style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        <Text style={{ fontSize: 14, color: '#339C98' }}>Encuestas realizadas</Text>
                                        <div style={{ fontSize: 32, fontWeight: 600, color: '#3E246B' }}>{relationshipsFinished}</div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </>
            }
            

            {/* Análisis centrado */}
            <Row gutter={[16, 16]} align="stretch">
                <Col xs={24} md={24}>
                    <Card bordered style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                        {(() => {
                            const format = (val) =>
                                typeof val === 'number' ? `${(Math.round(val * 100) / 100).toFixed(1)}%` : '0.0%';
                            const atributos = categories.find(c => c.name.toLowerCase().includes('atributo'));
                            const palancas = categories.find(c => c.name.toLowerCase().includes('palanca'));
                            const compromiso = categories.find(c => c.name.toLowerCase().includes('compromiso'));

                            const atributosPct = format(atributos?.average || 0);
                            const palancasPct = format(palancas?.average || 0);
                            const compromisoPct = format(compromiso?.average || 0);

                            return (
                                <Text style={{ fontSize: '12px', lineHeight: 1.8, textAlign: 'justify' }}>
                                    Frente a las categorías evaluadas la que obtuvo mayor favorabilidad fueron los <strong>Atributos culturales</strong> con un <strong>{atributosPct}</strong> y la de menor favorabilidad fueron las <strong>Palancas culturales</strong> con un <strong>{palancasPct}</strong>. La variable <strong>Compromiso</strong> tuvo un resultado del <strong>{compromisoPct}</strong>.
                                </Text>
                            );
                        })()}
                    </Card>
                </Col>
            </Row>
        </Space>
    );
};

export default CultureSummary;
